/**
 * @file conversationTimeConstants.js
 * @description Constants for the Conversation Time module within the Dashboard section.
 *              Includes tab labels and a date formatting utility function.
 *
 * @module conversationTimeConstants
 *
 * @exports CONVERSATIONTIME_TABS - Tab label strings for the conversation time panel.
 * @exports formatDateTime        - Utility function to format date/time values.
 */
export const CONVERSATIONTIME_TABS = {
    TEXTS: "Texts",
    EMAILS: "Emails",
};

export const formatDateTime = (value) => {
    if (!value) return null;
    if (value instanceof Date && !isNaN(value)) {
        const pad = (n, z = 2) => String(n).padStart(z, "0");
        return (
            value.getFullYear() + "-" +
            pad(value.getMonth() + 1) + "-" +
            pad(value.getDate()) + " " +
            pad(value.getHours()) + ":" +
            pad(value.getMinutes()) + ":" +
            pad(value.getSeconds()) + "." +
            pad(value.getMilliseconds(), 3)
        );
    }
    if (typeof value === "string") {
        return value.replace("T", " ").replace("Z", "");
    }
    return null;
};
